<div class="w-full overflow-y-hidden">
  <img-comparison-slider tabindex="0" class="rendered">
    <img slot="first" width="100%" src="/assets/img/dojo-before-1.jpeg" alt="ACA BJJ Dojo Before" />
    <img slot="second" width="100%" src="/assets/img/dojo-after-1.jpeg" alt="ACA BJJ Dojo After" />
  </img-comparison-slider>
</div>
